import { render, staticRenderFns } from "./staff-manage.vue?vue&type=template&id=70c654b0&scoped=true"
import script from "./staff-manage.vue?vue&type=script&lang=js"
export * from "./staff-manage.vue?vue&type=script&lang=js"
import style0 from "./staff-manage.vue?vue&type=style&index=0&id=70c654b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c654b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c654b0')) {
      api.createRecord('70c654b0', component.options)
    } else {
      api.reload('70c654b0', component.options)
    }
    module.hot.accept("./staff-manage.vue?vue&type=template&id=70c654b0&scoped=true", function () {
      api.rerender('70c654b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/staff-manage.vue"
export default component.exports